export default {
  "ltr": "npEpf",
  "rtl": "bOvX1",
  "iconContainer": "uzD6s",
  "icon": "KU-lu",
  "isExpanded": "TLz2i",
  "listDimensions": "ZXSQJ"
};